var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 72,
    viewBox: "0 0 75 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.13 46.7293C10.56 41.079 10.1004 34.7212 11.8319 28.7716L37.635 36.0002L13.13 46.7293Z",
    fill: "#FFB242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.133 13.2487C21.0878 14.9885 18.4217 17.2998 16.2869 20.0506C14.1521 22.8014 12.5904 25.9377 11.691 29.2806L37.6367 36L24.133 13.2487Z",
    fill: "#F2EA29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.5141 10.9071C27.5907 11.5066 25.7423 12.3171 24.0041 13.3232L37.6391 35.999L29.5141 10.9071Z",
    fill: "#FB6747"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.3455 10.9616C33.8452 9.52703 38.6515 9.28523 43.2772 10.2607L37.6382 36.0006L29.3455 10.9616Z",
    fill: "#8CD6A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.1882 10.2412C49.9309 11.6394 55.8668 15.5293 59.7659 21.1046C63.665 26.68 65.2282 33.5134 64.1317 40.1889L37.6392 35.9999L43.1882 10.2412Z",
    fill: "#0869FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M64.1285 40.1999C63.2063 45.7991 60.4658 50.9564 56.315 54.9041C52.1641 58.8518 46.8248 61.3788 41.0919 62.1089C35.3591 62.839 29.5392 61.7332 24.4986 58.956C19.458 56.1789 15.4663 51.8789 13.1177 46.6962L37.6377 36.0002L64.1285 40.1999Z",
    fill: "#3F42B7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.9290839949d2869dd11c91abca045dc2.svg";
export { ForwardRef as ReactComponent };